import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue';
import App from './App.vue'
import router from './router'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import * as VueGoogleMaps from "vue2-google-maps";

import {library} from '@fortawesome/fontawesome-svg-core'
import {faCopy, faImages} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

const fb = require('./config/firebaseConfig');

library.add(faCopy);
library.add(faImages);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyBRZl5Z2sWofXoHK9HJaQ_tQvTC6Q84epU",
        libraries: "places"
    }
});

Vue.use(BootstrapVue);
Vue.config.productionTip = false;

let app;

fb.auth.onAuthStateChanged(user => {
    if (!app) {
        app = new Vue({
            router,
            store,
            render: h => h(App)
        }).$mount('#app');
    }
});
